export default "__VITE_ASSET__o0$mW4Ki__"